<div *ngIf="visible"
     class="destination-overlay">
  <mat-card class="destination-panel file-panel">
    <!-- Custom close event handler to work with our component -->
    <mat-card-header>
      <app-window-title [closable]="true"
                        [closableStyle]="true"
                        [title]="'Clio Files in NuageDx'">
      </app-window-title>
    </mat-card-header>

    <!-- Add a separate close button that uses our handler since the window-title close button uses mat-dialog-close -->
    <button class="custom-close-button"
            style="position: absolute; top: 10px; right: 10px;"
            mat-icon-button
            (click)="handleClosePanel()">
      <mat-icon>
        close
      </mat-icon>
    </button>

    <mat-card-content>
      <!-- Add file list header -->
      <div class="file-list-header" *ngIf="nuageDxFiles.length > 0">
        <div class="header-column header-name">Name</div>
        <div class="header-column header-size">Size</div>
        <div class="header-column header-date">Last Modified</div>
      </div>

      <div *ngIf="nuageDxFiles.length > 0; else emptyState" class="file-list">
        <div *ngFor="let file of nuageDxFiles" class="file-item">
          <mat-icon class="file-icon">{{ file.type === 'image' ? 'image' : 'description' }}</mat-icon>
          <span class="file-name" matTooltip="{{file.name}}">{{ file.name }}</span>
          <span class="file-size">{{ file.size || 'N/A' }}</span>
          <span class="file-date">{{ file.lastModified || 'N/A' }}</span>
          <button mat-icon-button matTooltip="Open in Clio" (click)="backToClio(file.clioDocId)" *ngIf="file.clioDocId">
            <mat-icon>link</mat-icon>
          </button>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="empty-folder-message">
          <mat-icon>info</mat-icon>
          <p>No files have been transferred yet.</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
